const mr = {
  // Navigation
  'nav.dashboard': 'डॅशबोर्ड',
  'nav.algorithms': 'अल्गोरिदम',
  'nav.charts': 'चार्ट',
  'nav.brokers': 'ब्रोकर',
  'nav.tradingHistory': 'ट्रेडिंग इतिहास',
  'nav.paperTrading': 'पेपर ट्रेडिंग',
  'nav.portfolio': 'पोर्टफोलिओ',
  'nav.settings': 'सेटिंग्ज',
  'nav.screener': 'स्क्रीनर',
  'nav.marketplace': 'मार्केटप्लेस',
  'nav.journal': 'जर्नल',

  // Common actions
  'action.save': 'जतन करा',
  'action.cancel': 'रद्द करा',
  'action.delete': 'हटवा',
  'action.edit': 'संपादित करा',
  'action.create': 'तयार करा',
  'action.start': 'सुरू करा',
  'action.stop': 'थांबवा',
  'action.refresh': 'रिफ्रेश',
  'action.export': 'निर्यात',
  'action.import': 'आयात',
  'action.search': 'शोधा',
  'action.filter': 'फिल्टर',
  'action.back': 'मागे',
  'action.next': 'पुढे',
  'action.confirm': 'पुष्टी करा',
  'action.close': 'बंद करा',

  // Trading terms
  'trading.buy': 'खरेदी',
  'trading.sell': 'विक्री',
  'trading.long': 'लॉन्ग',
  'trading.short': 'शॉर्ट',
  'trading.profit': 'नफा',
  'trading.loss': 'तोटा',
  'trading.pnl': 'नफा/तोटा',
  'trading.winRate': 'विजय दर',
  'trading.totalTrades': 'एकूण ट्रेड',
  'trading.openPositions': 'खुल्या पोझिशन',
  'trading.balance': 'शिल्लक',
  'trading.symbol': 'सिंबल',
  'trading.quantity': 'प्रमाण',
  'trading.price': 'किंमत',
  'trading.entryPrice': 'प्रवेश किंमत',
  'trading.exitPrice': 'निर्गम किंमत',
  'trading.stopLoss': 'स्टॉप लॉस',
  'trading.takeProfit': 'टेक प्रॉफिट',
  'trading.status': 'स्थिती',

  // Status labels
  'status.active': 'सक्रिय',
  'status.paused': 'थांबलेले',
  'status.stopped': 'बंद',
  'status.draft': 'मसुदा',
  'status.completed': 'पूर्ण',
  'status.running': 'चालू',
  'status.failed': 'अयशस्वी',
  'status.pending': 'प्रलंबित',

  // Dashboard
  'dashboard.title': 'डॅशबोर्ड',
  'dashboard.todayPnl': 'आजचा नफा/तोटा',
  'dashboard.totalBalance': 'एकूण शिल्लक',
  'dashboard.activeAlgorithms': 'सक्रिय अल्गोरिदम',
  'dashboard.recentTrades': 'अलीकडील ट्रेड',

  // Settings
  'settings.title': 'सेटिंग्ज',
  'settings.language': 'भाषा',
  'settings.theme': 'थीम',
  'settings.notifications': 'सूचना',

  // Empty states
  'empty.noAlgorithms': 'अद्याप कोणतेही अल्गोरिदम नाहीत',
  'empty.noTrades': 'अद्याप कोणतेही ट्रेड नाहीत',
  'empty.noData': 'डेटा उपलब्ध नाही'
}

export default mr
